
import { mapState } from 'vuex'
import dateFormatMixin from '@/mixins/dateFormat'

import ProgressBar from '@/components/ProgressBar'
import HeroButton from '@/components/HeroButton'
import InfoIcon from '@/static/svg/prescription/info-icon.svg'
import VanIcon from '@/static/svg/prescription/van-icon.svg'

export default {
  components: {
    HeroButton,
    ProgressBar,
    InfoIcon,
    VanIcon,
  },
  mixins: [dateFormatMixin],
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isFilled: {
      type: Boolean,
      default: false,
    },
    isProductDisabled: {
      type: Boolean,
      default: false,
    },
    alternativeProduct: {
      type: Object,
      default: () => {},
    },
    hasValidationErrors: {
      type: Boolean,
      default: false,
    },
    stock: {
      type: Object,
      default: () => {},
    },
    selectedOptions: {
      type: Object,
      default: () => {},
    },
    deliveryDateFrom: {
      type: String,
      default: '',
    },
    deliveryDateTo: {
      type: String,
      default: '',
    },
    deliveryDateCutoff: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(['app']),
    isDisabledWithAlternative() {
      return this.isProductDisabled && this.alternativeProduct
    },
    isDisabledWithoutAlternative() {
      return this.isProductDisabled && !this.alternativeProduct
    },
    isBothEyesInvalid() {
      return this.isLeftEyeInvalid && this.isRightEyeInvalid
    },
    isJustLeftEyeInvalid() {
      return this.isLeftEyeInvalid && !this.isRightEyeInvalid
    },
    isJustRightEyeInvalid() {
      return !this.isLeftEyeInvalid && this.isRightEyeInvalid
    },
    isLeftEyeSelected() {
      return this.selectedOptions.leftEye.isSelected
    },
    isRightEyeSelected() {
      return this.selectedOptions.rightEye.isSelected
    },
    notEnoughStock() {
      const { stock, limited } = this.stock.leftEye
      const { isSelected: isLeftEyeSelected } = this.selectedOptions.leftEye
      const { isSelected: isRightEyeSelected } = this.selectedOptions.rightEye
      const leftEyeOptions = JSON.stringify(this.selectedOptions.leftEye.options)
      const rightEyeOptions = JSON.stringify(this.selectedOptions.rightEye.options)
      const sameOptions = leftEyeOptions === rightEyeOptions
      const bothEyesSelected = isLeftEyeSelected && isRightEyeSelected

      return stock === 1 && limited && sameOptions && bothEyesSelected
    },
    isDisabled() {
      const { isSelected: isLeftEyeSelected } = this.selectedOptions.leftEye
      const { isSelected: isRightEyeSelected } = this.selectedOptions.rightEye
      const { limited: isLeftEyeLimited, stock: leftEyeStock, error: leftEyeErrors } = this.stock.leftEye
      const { limited: isRightEyeLimited, stock: rightEyeStock, error: rightEyeErrors } = this.stock.rightEye
      const { limited: accessoryStockLimited = false, stock: accessoryStock } = this.stock.accessory

      return (
        (isLeftEyeSelected && ((isLeftEyeLimited && leftEyeStock === 0) || !!leftEyeErrors)) ||
        (isRightEyeSelected && ((isRightEyeLimited && rightEyeStock === 0) || !!rightEyeErrors)) ||
        this.hasValidationErrors ||
        (!isLeftEyeSelected && !isRightEyeSelected && !this.isFilled) ||
        this.notEnoughStock ||
        (accessoryStockLimited && accessoryStock === 0)
      )
    },
    hasLimitedStock() {
      const { limited: isLeftEyeLimited, stock: leftEyeStock } = this.stock.leftEye
      const { limited: isRightEyeLimited, stock: rightEyeStock } = this.stock.rightEye
      const { limited: accessoryStockLimited = false, stock: accessoryStock } = this.stock.accessory

      return !!(
        (isLeftEyeLimited && leftEyeStock === 0 && this.isLeftEyeSelected) ||
        (isRightEyeLimited && rightEyeStock === 0 && this.isRightEyeSelected) ||
        this.notEnoughStock ||
        (accessoryStockLimited && accessoryStock === 0)
      )
    },
    isLeftEyeInvalid() {
      return !!this.stock.leftEye.error && this.isLeftEyeSelected
    },
    isRightEyeInvalid() {
      return !!this.stock.rightEye.error && this.isRightEyeSelected
    },
    showSuccess() {
      return (
        (!!this.deliveryDateFrom || !!this.deliveryDateTo) && !this.showWarning && !this.showError && !this.isLoading
      )
    },
    showWarning() {
      return this.hasLimitedStock || this.isLeftEyeInvalid || this.isRightEyeInvalid || this.isProductDisabled
    },
    showError() {
      return this.hasValidationErrors
    },
    storeLocatorEnabled() {
      return this.app?.storeLocator?.enabled
    },
  },
  methods: {
    goToLink(link) {
      this.$router.push(link)
    },
    goToEyeTest() {
      this.$router.push(this.$getLink('/store-locator'))
    },
    addToBasket() {
      this.$emit('added-to-basket')
    },
  },
}
